import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/infooutline.png';
const _hoisted_1 = { class: "progress-dial-main" };
const _hoisted_2 = {
    key: 0,
    class: "progress-dial-header"
};
const _hoisted_3 = { class: "progress-dial-title" };
const _hoisted_4 = { class: "progress-dial-title" };
const _hoisted_5 = { class: "progress-dial-gauge" };
const _hoisted_6 = {
    viewBox: "0 0 200 108",
    class: "progress-dial-svg"
};
const _hoisted_7 = ["stroke", "stroke-dashoffset"];
const _hoisted_8 = ["stroke"];
const _hoisted_9 = ["cx", "cy", "fill"];
const _hoisted_10 = { class: "progress-dial-labels" };
const _hoisted_11 = { class: "progress-dial-label" };
const _hoisted_12 = { class: "progress-dial-label" };
const _hoisted_13 = {
    key: 1,
    class: "progress-dial-message-section"
};
const _hoisted_14 = { class: "progress-dial-message" };
const _hoisted_15 = {
    key: 0,
    class: "progress-dial-check-icon"
};
const _hoisted_16 = {
    key: 1,
    src: _imports_0,
    class: "progress-dial-info-icon"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
    key: 0,
    class: "progress-dial-footer"
};
const _hoisted_19 = { class: "progress-dial-footer-text" };
const _hoisted_20 = { class: "progress-dial-footer-text" };
import { ref, computed, onMounted, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProgressDial',
    props: {
        fromDate: {},
        toDate: {},
        title: {},
        footerLabel: {},
        animationDuration: {}
    },
    setup(__props) {
        const props = __props;
        const currentProgress = ref(0);
        const displayNumber = ref(0);
        const arcLength = Math.PI * 92;
        const total = computed(() => {
            const from = new Date(props.fromDate);
            const to = new Date(props.toDate);
            return Math.round((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
        });
        const value = computed(() => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const to = new Date(props.toDate);
            return Math.max(0, Math.round((to.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)));
        });
        const startLabel = computed(() => formatDate(props.fromDate));
        const endLabel = computed(() => formatDate(props.toDate));
        const footerValue = computed(() => formatDate(props.toDate));
        const targetProgress = computed(() => {
            if (total.value <= 0)
                return 0;
            return Math.max(0, Math.min(1, (total.value - value.value) / total.value));
        });
        const currentOffset = computed(() => arcLength * (1 - currentProgress.value));
        const progressDotPosition = computed(() => {
            const angle = Math.PI * (1 - currentProgress.value);
            return {
                x: 100 + 92 * Math.cos(angle),
                y: 100 - 92 * Math.sin(angle)
            };
        });
        const barColour = computed(() => value.value <= 30 ? '#E53935' : '#7FD038');
        const activeColour = computed(() => barColour.value);
        const displayText = computed(() => value.value <= 0 ? 'Expired' : displayNumber.value);
        const isAllSet = computed(() => targetProgress.value < 1 && value.value > 30);
        const message = computed(() => {
            if (targetProgress.value >= 1)
                return '<b>Policy has expired</b> – you may no longer be covered. Compare new policies.';
            if (value.value <= 30)
                return '<b>Policy renews soon</b> – start reviewing your cover so you\'re ready to switch or renew.';
            return '<b>You\'re all set</b> – there\'s plenty of time before you\'ll need to review this policy.';
        });
        function formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        }
        function animate() {
            const startTime = performance.now();
            const tp = targetProgress.value;
            const tv = value.value;
            const duration = props.animationDuration ?? 1500;
            const step = (currentTime) => {
                const elapsed = currentTime - startTime;
                const t = Math.min(elapsed / duration, 1);
                const eased = 1 - Math.pow(1 - t, 3);
                currentProgress.value = tp * eased;
                displayNumber.value = Math.round(total.value - (total.value - tv) * eased);
                if (t < 1) {
                    requestAnimationFrame(step);
                }
            };
            requestAnimationFrame(step);
        }
        onMounted(() => {
            animate();
        });
        watch(() => props.fromDate, () => animate());
        watch(() => props.toDate, () => animate());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "progress-dial",
                style: _normalizeStyle({ '--progress-colour': activeColour.value })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(displayText.value), 1)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                            _cache[0] || (_cache[0] = _createElementVNode("path", {
                                d: "M 8 100 A 92 92 0 0 1 192 100",
                                fill: "none",
                                stroke: "#F5F4F6",
                                "stroke-width": "5",
                                "stroke-linecap": "round"
                            }, null, -1)),
                            _createElementVNode("path", {
                                d: "M 8 100 A 92 92 0 0 1 192 100",
                                fill: "none",
                                class: "progress-arc",
                                stroke: barColour.value,
                                "stroke-dasharray": arcLength,
                                "stroke-dashoffset": currentOffset.value
                            }, null, 8, _hoisted_7),
                            _createElementVNode("circle", {
                                cx: "192",
                                cy: "100",
                                r: "5",
                                fill: "white",
                                stroke: currentProgress.value >= 1 ? barColour.value : '#F5F4F6',
                                "stroke-width": "4"
                            }, null, 8, _hoisted_8),
                            (currentProgress.value > 0.01)
                                ? (_openBlock(), _createElementBlock("circle", {
                                    key: 0,
                                    cx: progressDotPosition.value.x,
                                    cy: progressDotPosition.value.y,
                                    r: "5",
                                    fill: barColour.value
                                }, null, 8, _hoisted_9))
                                : _createCommentVNode("", true)
                        ])),
                        _createElementVNode("div", {
                            class: "progress-dial-value",
                            onClick: animate
                        }, _toDisplayString(displayNumber.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(startLabel.value), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(endLabel.value), 1)
                    ]),
                    (message.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "progress-dial-divider" }, null, -1)),
                            _createElementVNode("div", _hoisted_14, [
                                (isAllSet.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                                _createElementVNode("span", {
                                    class: "progress-dial-message-text",
                                    innerHTML: message.value
                                }, null, 8, _hoisted_17)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.footerLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.footerLabel), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(footerValue.value), 1)
                    ]))
                    : _createCommentVNode("", true)
            ], 4));
        };
    }
});
